import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDialogModule } from '@angular/material/dialog';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MobileFixedMenuModule } from './modules/mobile-fixed-menu/mobile-fixed-menu.module';

import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { FomanticUIModule } from 'ngx-fomantic-ui';
import { ForceConfirmModalComponent } from './force-confirm-modal/force-confirm-modal.component';
import { SupportComponent } from './support/support.component';
import { SelectDropdownComponent } from './select-dropdown/select-dropdown.component';
import { DropzoneComponent } from './components/dropzone/dropzone.component';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { ImageCropperContainerComponent } from './image-cropper-container/image-cropper-container.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { FileDropzoneDirective } from './directives/file-dropzone.directive';
import { ImagePreviewComponent } from './image-preview/image-preview.component';
import { IsArrayValidPipe } from './pipes/is-array-valid.pipe';
import { ToastModule } from 'primeng/toast';

@NgModule({
  imports: [
    CommonModule,
    ToastModule,
    HttpClientModule,
    FomanticUIModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    MatDialogModule,
    ImageCropperModule,
    NgxSliderModule,
    SwiperModule,
    MobileFixedMenuModule,
  ],
  declarations: [
    LoadingSpinnerComponent,
    ConfirmModalComponent,
    ForceConfirmModalComponent,
    SupportComponent,
    SelectDropdownComponent,
    DropzoneComponent,
    EmptyStateComponent,
    ImageCropperContainerComponent,
    FileDropzoneDirective,
    ImagePreviewComponent,
    IsArrayValidPipe,
  ],
  exports: [
    LoadingSpinnerComponent,
    ConfirmModalComponent,
    ForceConfirmModalComponent,
    SupportComponent,
    SelectDropdownComponent,
    EmptyStateComponent,
    NgSelectModule,
    ImageCropperContainerComponent,
    FileDropzoneDirective,
    ImagePreviewComponent,
    MobileFixedMenuModule,
    IsArrayValidPipe,
  ],
  entryComponents: [
    ConfirmModalComponent,
    ForceConfirmModalComponent,
    SupportComponent,
  ],
})
export class UiModule {}
